import axios from 'axios';
import Nprogress from 'nprogress';
import 'nprogress/nprogress.css';
import { getTokenSSO } from '../utils/index';
import { openNotification, typesNotification } from '../utils/notifications';
import { modalLoginSSO } from '../utils/sso';

const configAxios = () => {
  axios.interceptors.request.use(
    function (config) {
      Nprogress.start();
      if (config.withCredentials !== false) {
        config.timeout = 180000;
        config.headers.token = getTokenSSO();
        config.headers.url = window.location.href.substring(0, 255);
      }
      return config;
    },
    function (error) {
      Nprogress.done();
      return Promise.reject(error);
    }
  );

  axios.interceptors.response.use(
    function (response) {
      Nprogress.done();
      if (!response) {
        modalLoginSSO(true);
      }
      return response;
    },
    async function (error) {
      Nprogress.done();
      if (error.response && (error.response.data || error.response.status)) {
        const statusCode = error.response.status;
        if (statusCode === 400 && error.response.data) {
          let data;
          if (error.response.data instanceof Blob) {
            data = JSON.parse(await error.response.data.text());
          } else {
            data = error.response.data;
          }
          let msg = data.message || data.messages || data.mensagemErro || error.response.data.mensagem;
          openNotification(typesNotification.error, '<strong>Atenção</strong> <br/>' + msg);
        } else if (statusCode === 403) {
          let msg = error.response.data.message || error.response.data.messages || error.response.data.mensagem;
          openNotification(typesNotification.error, '<strong>Sem permissão </strong> <br/>' + msg);
        } else if (statusCode === 401) {
          let isModal = true;
          try {
            isModal = error.response.config.url.indexOf('ssows') > -1 ? false : true;
          } catch (error) {
            //console.error(error);
          }
          if (isModal) modalLoginSSO(true);
          return Promise.resolve(error);
        } else if (statusCode === 409) {
          openNotification(typesNotification.warning, `Existe um conflito de dados`, 8000);
          return Promise.reject(error);
        } else {
          openNotification(typesNotification.error, `Algo estranho acontenceu - StatusCode é ${statusCode}, Se necessário contate o suporte ou aguarde um momento...`, 8000);
        }
      } else {
        if (error.response === 'Error: Network Error') {
          openNotification(typesNotification.info, `Falha <br/>Não foi possível acessar o serviço - ${error.config.url}`, 8000);
        } else {
          openNotification(typesNotification.error, `Erro ao conectar no service, <br/>${error.message} - ${error.config.url}`, 8000);
        }
      }
      return Promise.reject(error);
    }
  );
};

export default configAxios;
